import { render, staticRenderFns } from "./profitDetails.vue?vue&type=template&id=54615879&"
import script from "./profitDetails.vue?vue&type=script&lang=js&"
export * from "./profitDetails.vue?vue&type=script&lang=js&"
import style0 from "./profitDetails.vue?vue&type=style&index=0&id=54615879&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports